import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { ModalsProvider } from '@mantine/modals';
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/dates/styles.css';

import { Web3Provider } from './contexts/Web3Context';
import { SupabaseProvider } from './contexts/SupabaseContext';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import AccountManagement from './pages/AccountManagement';
import LockupManagement from './pages/LockupManagement';
import TokenControl from './pages/TokenControl';
import SnapshotManagement from './pages/SnapshotManagement';
import Login from './pages/Login';
import { useSupabase } from './contexts/SupabaseContext';
import AdminManagement from './pages/AdminManagement';

const PrivateRoute = ({ children }) => {
  const { session, isAuthLoading } = useSupabase();
  if (isAuthLoading) return null;
  return session ? children : <Navigate to="/login" replace />;
};

function App() {
  return (
    <MantineProvider>
      <ModalsProvider>
        <Notifications />
        <SupabaseProvider>
          <Web3Provider>
            <Router>
              <Layout>
                <Routes>
                  <Route path="/login" element={<Login />} />
                  <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
                  <Route path="/accounts" element={<PrivateRoute><AccountManagement /></PrivateRoute>} />
                  <Route path="/lockup" element={<PrivateRoute><LockupManagement /></PrivateRoute>} />
                  <Route path="/token" element={<PrivateRoute><TokenControl /></PrivateRoute>} />
                  <Route path="/snapshot" element={<PrivateRoute><SnapshotManagement /></PrivateRoute>} />
                  <Route path="/admin" element={<PrivateRoute><AdminManagement /></PrivateRoute>} />
                </Routes>
              </Layout>
            </Router>
          </Web3Provider>
        </SupabaseProvider>
      </ModalsProvider>
    </MantineProvider>
  );
}

export default App;
